<div class="styled-box" *ngIf="!isArchiveUploaded">
  <span>Upload the final document. </span>
</div>
<div
  class="uploader-class text-align-left"
  [ngClass]="{
    'hide-uploader':
      !permissionObj['GLOBAL_ENG_SubmissionDetails_DragAndDrop_Visible']
  }"
>
  <dds-uploader
    *ngIf="
      permissionObj['GLOBAL_ENG_SubmissionDetails_DragAndDrop_Visible'] &&
      isSubmissionStatusDraft
    "
    id="global-eng-uploader"
    [heading]="uploadAreaOptions.heading ?? emptyString"
    [description]="uploadAreaOptions.description ?? emptyString"
    [dragAndDropText]="uploadAreaOptions.dragAndDropText ?? emptyString"
    [isDragAndDrop]="uploadAreaOptions.isDragAndDrop ?? false"
    [isMultiple]="uploadAreaOptions.isMultiple ?? true"
    [acceptFormats]="uploadAreaOptions.acceptFormats ?? emptyString"
    [acceptExtensions]="uploadAreaOptions.acceptExtensions ?? emptyString"
    [restrictedFormats]="uploadAreaOptions.restrictedFormats ?? emptyString"
    [restrictedExtensions]="
      uploadAreaOptions.restrictedExtensions ?? emptyString
    "
    [exceptSymbols]="uploadAreaOptions.exceptSymbols ?? emptyString"
    [btnLabel]="uploadAreaOptions.btnLabel ?? emptyString"
    [isInverse]="uploadAreaOptions.isInverse ?? false"
    [chooseFileBtnKind]="uploadAreaOptions.chooseFileBtnKind ?? emptyString"
    [disabled]="!permissionObj['GLOBAL_ENG_SubmissionDetails_DragAndDrop_Enable']"
    (uploadedItems)="openUploadModel($event)"
  ></dds-uploader>

  <dds-button
    *ngIf="isSubmissionStatusDraft"
    class="absolute button-style margin-left-xs"
    [theme]="buttonOptions.theme ?? emptyString"
    [kind]="buttonOptions.kind ?? emptyString"
    [size]="buttonOptions.size ?? emptyString"
    [width]="buttonOptions.width ?? emptyString"
    (click)="openDocumentLinkModal()"
    >Add link</dds-button
  >
</div>

<app-engagement-table
  *ngIf="permissionObj['GLOBAL_ENG_SubmissionDetails_DocumentsTable_Visible']"
  [submissionId]="submissionId"
  [submissionTypeId]="submissionTypeId"
  [permissionObj]="permissionObj"
  [isSubmissionStatusDraft]="isSubmissionStatusDraft"
  (onDocumentChange)="onDocumentChange($event)"
  (documentUploaded)="getAllUploadedDocuments($event)"
></app-engagement-table>
